export default "__VITE_ASSET__e042308d__"